export const EcommerceLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M13.6998 23.2C12.6548 23.2 11.8094 24.055 11.8094 25.1C11.8094 26.145 12.6548 27 13.6998 27C14.7448 27 15.5997 26.145 15.5997 25.1C15.5997 24.055 14.7448 23.2 13.6998 23.2ZM8 8V9.9H9.89993L13.3198 17.1105L12.0374 19.438C11.8854 19.704 11.7999 20.0175 11.7999 20.35C11.7999 21.395 12.6548 22.25 13.6998 22.25H25.0994V20.35H14.0988C13.9658 20.35 13.8613 20.2455 13.8613 20.1125L13.8898 19.9985L14.7448 18.45H21.822C22.5345 18.45 23.1615 18.0605 23.4845 17.4715L26.8854 11.306C26.9637 11.161 27.0032 10.9982 26.9998 10.8334C26.9964 10.6686 26.9504 10.5075 26.8662 10.3659C26.7819 10.2242 26.6624 10.1068 26.5192 10.0252C26.3761 9.9435 26.2142 9.90038 26.0494 9.9H11.9994L11.1064 8H8ZM23.1995 23.2C22.1545 23.2 21.309 24.055 21.309 25.1C21.309 26.145 22.1545 27 23.1995 27C24.2444 27 25.0994 26.145 25.0994 25.1C25.0994 24.055 24.2444 23.2 23.1995 23.2Z"
        fill="#05050D"
      />
    </svg>
  );
};
